module.exports = __webpack_public_path__ + "img/icon_listmytools_handoff.871440dd.svg";